import React from "react";
import {Box, Button, Card, CardContent, CardHeader, Typography} from "@mui/material";
import User from "../backend/User";

function NoTenantPage() {
    const handleLogout = () => {
        User.logout();
        window.location = process.env.PUBLIC_URL + "/login";
    };

    return (
        <div style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
        }}>
            <Card sx={{maxWidth: 480}}>
                <CardHeader
                    title={"WebTrain"}
                    style={{backgroundColor: "rgb(0,150,136)", color: 'white'}}
                />
                <CardContent sx={{textAlign: 'center', py: 4}}>
                    <Typography variant="h6" gutterBottom>
                        Kein Zugang
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{mb: 3}}>
                        Ihrer Organisation ist kein Zugang zu WebTrain zugewiesen.
                        Bitte wenden Sie sich an Ihren Administrator.
                    </Typography>
                    <Box>
                        <Button variant="contained" color="primary" onClick={handleLogout}>
                            Abmelden
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </div>
    );
}

export default NoTenantPage;
